module.exports = __webpack_public_path__ + "img/marker-west.ce3c7959.svg";